import { Spinner } from "@/components/Spinner";

export default function SSOLoginPage() {
  return (
    <div className="h-full flex items-center justify-center">
      <Spinner />
    </div>
  );
}
